import {SubItemsConfig} from '@/services/schema/OrderItemOverview/SubItems/SubItemsConfig.js'

export const useItemOverview = () => {
  return {
    subItemColConfigData: SubItemsConfig || [],
  }
}
